//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#TERRAIN_CLASSIFICATION}\n\
 *\n\
 * @name czm_passTerrainClassification\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passTerrainClassification = 3.0;\n\
";